import { INamHocActions } from "../../action-types/category/INamHocActionType";
import { INamHocReducer } from "../../reducer-model/category/INamHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: INamHocReducer = {
    status: eReducerStatusBase.is_not_initialization,
    namHocs: []
}
export const namHocReducer = (state: INamHocReducer = iniState, action: INamHocActions): INamHocReducer => {
    switch (action.type) {
        case "NAM_HOC_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "NAM_HOC_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                namHocs: action.payload
            }
        case "NAM_HOC_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "NAM_HOC_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                namHocEditing: action.payload
            }
        case "NAM_HOC_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "NAM_HOC_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "NAM_HOC_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "NAM_HOC_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "NAM_HOC_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "NAM_HOC_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "NAM_HOC_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}